<template>
    <div class="flex items-center gap-2">
        <input type="checkbox" class="toggle toggle-large" name="pass_on_fees" id="pass_on_fees" value="true" @input="$emit('toggle')" :checked="toggled"/>
        <label for="pass_on_fees" class="text-sm">{{  label  }}</label>
    </div>
</template>

<script>
export default {
  props: {
    label: {
      type: String
    },
    toggled: {
      type: Boolean,
      default: false
    }
  },
  data: () => {
    return {
      editLevel: null,
      editSponsor: null,
      hasConfig: false,
      hasFetched: false,
      eventSponsorConfig: {
        about_text: '',
        levels: [],
        pass_on_fees: true
      },
      eventSponsors: [],
      originalEventSponsorConfigLevelOrder: []
    }
  }
}
</script>
<!-- From https://blog.bitsrc.io/how-to-create-a-css-only-toggle-switch-adf2bb21346f -->
<style>
    :root {
        /* Used color variables */
        --toggle-gray:#e2e8f0;
        --toggle-green: #48bb78;
        --toggle-white: #ffffff;
        --toggle-transparent: transparent;

        /* Toggle variables */
        --toggle-size: 1em;
        --toggle-border-thickness: 0.1em;
        --toggle-color-border: var(--toggle-transparent);
        --toggle-color-background: var(--toggle-gray);
        --toggle-color-ball: var(--toggle-white);
        --toggle-border-radius-inner: calc(var(--toggle-size) / 2);
        --toggle-border-radius: calc(
        var(--toggle-border-radius-inner) + var(--toggle-border-thickness)
        );
    }

    .toggle-large {
        font-size: 1.4rem !important;
    }

    .toggle {
        appearance: none;
        position: relative;
        cursor: pointer;

        box-sizing: content-box;
        display: inline-block;
        vertical-align: middle;
        width: calc((var(--toggle-size) * 2) - 2px);
        height: var(--toggle-size);
        border: var(--toggle-border-thickness) solid var(--toggle-color-border);
        border-radius: var(--toggle-border-radius);

        font-size: inherit;
        background: var(--toggle-color-background);

        transition: background 0.4s;
    }

    .toggle:before {
        content: "";
        position: absolute;
        left: calc((var(--toggle-size) * 0.1) - 2px);

        width: var(--toggle-size);
        height: var(--toggle-size);
        border-radius: var(--toggle-border-radius-inner);

        background-color: var(--toggle-color-ball);
        transition: background-color 0.4s, left 0.4s;
    }

    .toggle:checked {
        --toggle-color-background: var(--toggle-green);
    }

    .toggle:checked:before {
        --toggle-color-ball: var(--toggle-white);
        left: calc(var(--toggle-size) * 0.9);
    }
</style>
